import React from 'react';
import Container from './Container';
import ChatFeedList from './List';
import ChatFeedItem from './Item';
import withMessagingHoc from '../../../common/hoc/withMessaging'

const ChatFeedContainer = (props) => {
    const { withMessaging, ...rest } = props
    
    if(withMessaging) {
        return withMessagingHoc(Container)(props)
    }

    return <Container {...rest} />
}

export { ChatFeedContainer as default, ChatFeedList, ChatFeedItem };